import axios from 'axios';

axios.interceptors.response.use((response) => {

    return response;
  }, error => {
    
    if(error.response && error.response.status ==401){
        var url = error.request.responseURL ? error.request.responseURL : error.response.config.url;
        if (!url.endsWith("/Code") && !url.endsWith("/CodePDF")) {        
         //Authenticated request redirected but "Code" based calls pass thru
            window.location= `${process.env.REACT_APP_LOGIN_URL}?ReturnUrl=${window.location.href}`;    
        }
    }        
    return Promise.reject(error);
  });

axios.interceptors.request.use(
  request=> {
        request.headers["X-Application-Name"] = "Correspondence Manager";
        return request;
  },
  error=> {
    return Promise.reject(error);
  }
);
  

export const getLoggedInUserInfo = async () => {
    var temp = await axios.get(`${ process.env.REACT_APP_API_URL }/api/Login/LoggedInUserInfo`, {withCredentials: true} );
    return temp.data;    
}


export const login = async (userName) => {
    var temp = await axios.post(`${process.env.REACT_APP_API_URL}/api/Login`, {userName}, {withCredentials: true} );
    return temp.data;    
}

export const getRecipientFormsList = async (recipientId,adminRequestedType) => {
    var url = `${ process.env.REACT_APP_API_URL }/api/FormInstance/RecipientFormInstanceList/${recipientId}`;
    if(adminRequestedType)
        url+=`?adminRequestedType=${adminRequestedType}`;
    var temp = await axios.get( url , {withCredentials: true} );
    return temp.data;
};

export const deleteInstance = async (id) => {
    var temp = await axios.delete(`${ process.env.REACT_APP_API_URL }/api/FormInstance/${id}`, {withCredentials: true} );
    return temp.data;
};

export const getInstance = async id => {
    var temp = await axios.get(`${ process.env.REACT_APP_API_URL }/api/FormInstance/${id}`, {withCredentials: true});
    return temp.data;
};

export const addInstance = async (selectedRecipientId, formId)=> {

        console.log(formId);
        await axios.post(`${process.env.REACT_APP_API_URL}/api/FormInstance`, {formId, selectedRecipientId } , {withCredentials: true});
};

export const getUsers = async (searchText,lookupType) => {
    var temp = await axios.get(`${ process.env.REACT_APP_API_URL }/api/Login/CarrierOrEmployerUsers/${lookupType}/?searchText=${searchText}&maxNumber=25`);
    return temp.data;
};

export const getEmployerOrCarrierRecipients = async(searchText,lookupType) => {
    var temp = await axios.get(`${process.env.REACT_APP_API_URL}/api/Login/EmployerOrCarrierRecipients/${lookupType}/?searchText=${searchText}&maxNumber=25`, { withCredentials: true });
    return temp.data;
};

export const getForm = async id => {
    var temp = await axios.get(`${ process.env.REACT_APP_API_URL }/api/Form/${id}`, {withCredentials: true});
    return temp.data;
};

export const getAllForms = async recipientId => {
    var temp = await axios.get(`${process.env.REACT_APP_API_URL}/api/Form/User/${recipientId}`, {withCredentials: true}); //should remove and use cookie
    return temp.data;
};

export const refreshCookie = async() => {
    var temp = await axios.post(`${process.env.REACT_APP_API_URL}/api/TicketRefresh/`, {withCredentials: true}); //should remove and use cookie
    return temp.data;
};


export const postForm = async json => {
    try {
        var data = await axios.post(`${process.env.REACT_APP_API_URL}/api/Form`, json, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        console.log(data);
    } catch (error) {
        console.log(error);
        throw(error);
    }
}

export const postFormInstance = async json => {
    try {
        var data = await axios.post(`${process.env.REACT_APP_API_URL}/api/FormInstance`, json, {withCredentials: true});
        console.log(data);
    } catch (error) {
        console.log(error);
        throw(error);
    }
}
export const putFormData = async json => {
    try {
        var data = await axios.put(`${process.env.REACT_APP_API_URL}/api/FormInstance`, json, {withCredentials: true});
        return data;
    } catch (error) {
        throw(error);    
    }
}


export const getInternalDirect = async key => {
    try {
        var data = await axios.post(`${process.env.REACT_APP_API_URL}/api/FormInstance/InternalDirect`,{"key":key}, {withCredentials: true});
        return data;
    } catch (error) {
        throw(error);    
    }
}

export const getExternalDirect = async key => {
    try {
        var data = await axios.post(`${process.env.REACT_APP_API_URL}/api/FormInstance/ExternalDirect`,{"key":key}, {withCredentials: true});
        return data;
    } catch (error) {
        throw(error);    
    }
}

export const getDataByCode = async (key1,key2) => {
    try {
        var data = await axios.post(`${process.env.REACT_APP_API_URL}/api/FormInstance/Code`,{"Key1":key1,"Key2":key2 }, {withCredentials: true});
        return data;
    } catch (error) {
        throw(error);    
    }
}

export const getFormListByCode = async (key1,key2) => {
    try {
        var data = await axios.post(`${process.env.REACT_APP_API_URL}/api/FormInstance/RecipientFormInstanceListForCode`,{"Key1":key1,"Key2":key2 }, {withCredentials: true});
        return data;
    } catch (error) {
        throw(error);    
    }
}

export const putFormDataForCode = async json => {
    try {
        var data = await axios.put(`${process.env.REACT_APP_API_URL}/api/FormInstance/Code`, json, {withCredentials: true});
        return data;
    } catch (error) {
        throw(error);    
    }
}

export const getAnalyticsData = async (key) => {
    try {
        var data = await axios.get(`${process.env.REACT_APP_API_URL}/api/Analytics?k=${key}`);
        return data;
    } catch (error) {
        throw(error);    
    }
}
